export default "<p>cohome works!</p>\n"